import React, { useEffect, lazy } from 'react';
import { useSelector } from 'react-redux';
import {
	Switch,
	Redirect,
	Route,
	useLocation,
	useHistory,
} from 'react-router-dom';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { initialized } from 'modules/gtm/selectors';
import { roles } from 'utility/constants/roles';

const Marketplace = lazy(() => import('pages/shop/Marketplace'));

const AddProduct = lazy(() => import('pages/shop/AddProduct'));

const BasketItemWizard = lazy(() => import('pages/shop/BasketItemWizard'));

const DomainSearch = lazy(() => import('pages/domains/Register/Search'));

const DomainConfigure = lazy(() => import('pages/domains/Register/Configure'));

const ConfigPackage = lazy(() => import('pages/shop/ConfigPackage'));

const NotFound = lazy(() => import('pages/NotFound'));

const ShopRouter = () => {
	const location = useLocation();
	const history = useHistory();
	const gtmInitialized = useSelector(initialized);
	useEffect(() => {
		// can't do navigation events until GTM has been initialized
		if (gtmInitialized && location.pathname === '/shop') {
			history.replace('/shop/marketplace');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, gtmInitialized]);

	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/shop/marketplace/:tab"
				component={Marketplace}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/marketplace"
				component={Marketplace}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/domain"
				component={DomainSearch}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/shop/domain/configure"
				component={DomainConfigure}
				whitelistedRoles={[roles.PURCHASER, roles.SETUP_USER]}
			/>
			<Route exact path="/shop/add/:productCode" component={AddProduct} />
			<Route
				exact
				path="/shop/config/:productKey/:step"
				component={BasketItemWizard}
			/>
			<Route
				exact
				path="/shop/config/:productKey"
				component={BasketItemWizard}
			/>
			<Route
				exact
				path="/shop/package/:packageCode"
				component={ConfigPackage}
			/>
			<Route
				exact
				path="/shop/package/:packageCode/:uuid"
				component={ConfigPackage}
			/>

			<Route path="/shop/payment-method">
				<Redirect to="/cart" />
			</Route>
			<Route path="/shop/checkout">
				<Redirect to="/cart" />
			</Route>
			<Route path="/shop/special-offers">
				<Redirect to="/cart" />
			</Route>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default ShopRouter;
